import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { indonesiaTours } from '../data/tours';

export const KomodoTourPage = () => {
  const tour = indonesiaTours.find(t => t.id === 'komodo-liveaboard');
  return <TourDetailPage tour={tour} />;
};
